import { get } from "../../../utils/objectHelpers";

$ {
    const text = get(input, "text", {});
    const status = get(input, "status", "neutral");
}

<ebay-signal status=status>
    <str-textual-display ...text />
</ebay-signal>
